module.exports = __webpack_public_path__ + "static/media/ali.5efef102.jpg";